/**
 * Ryan O'Dowd
 * 2021-06-28
 * © Copyright 2021 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      display: 'flex',
      fontFamily: fonts.primary,
      fontSize: globalScale * 14,
    },
    link: {
      color: colors.accentDark,
      cursor: 'pointer',
      textDecorationLine: 'underline',
    },
  };
};

export default getStyles;
